import WMUWCBundleChildProduct from "./child-product";
import WMUWCBundleChildProductVariable from "./child-product-variable";

/**
 * 
 */
class WMUWCAddToCartBundle {

	/**
	 * 
	 * @type String
	 */
	addToCartBtnSelector = '.single_add_to_cart_button';

	/**
	 * 
	 * @type Number
	 */
	bundleId = undefined;

	/**
	 * 
	 * @type String
	 */
	bundleIdInputSelector = 'input[name="product_id"]';

	/**
	 * 
	 * @type WMUWCBundleChildProduct[]
	 */
	childrenProductList = [];

	/**
	 * 
	 * @type String
	 */
	childrenProductSelector = '.bundle-product';

	/**
	 * 
	 * @type Number
	 */
	price = undefined;

	/**
	 * 
	 * @type String
	 */
	priceHtml = '';

	/**
	 * 
	 * @type String
	 */
	priceElementSelector = '.block-single-product-price > .block-inner';

	/**
	 * 
	 * @type Number
	 */
	refreshVariationTimeoutId = undefined;

	/**
	 * 
	 * @type String
	 */
	variableAttributeSelectSelector = '.variations select';

	/**
	 * 
	 * @type String
	 */
	variationIdsInputSelector = 'input[name="variation_ids"]';

	/**
	 * 
	 */
	constructor()
	{
		this.init();
	}

	/**
	 * 
	 */
	init()
	{
		this.onDOMContentLoaded = this.onDOMContentLoaded.bind( this );
		document.addEventListener( 'DOMContentLoaded', this.onDOMContentLoaded );

		this.onChildVariationRefresh = this.onChildVariationRefresh.bind( this );
		document.addEventListener( 'wmuwc/bundleProduct/variationRefresh', this.onChildVariationRefresh );

		this.onChildVariationRefreshTimeout = this.onChildVariationRefreshTimeout.bind( this );
	}

	/**
	 * 
	 * @param {HTMLElement} contextElement 
	 */
	findBundleId( contextElement = null )
	{
		if ( null === contextElement )
		{
			contextElement = document;
		}

		const bundleIdInput = contextElement.querySelector( this.bundleIdInputSelector );

		if ( ! bundleIdInput )
		{
			console.error( 'Unable to find the bundle ID input' );
		}

		this.bundleId = bundleIdInput.value;
	}

	/**
	 * 
	 * @param {HTMLElement} contextElement 
	 */
	findChildrenProduct( contextElement = null )
	{
		if ( null === contextElement )
		{
			contextElement = document;
		}

		contextElement.querySelectorAll( this.childrenProductSelector ).forEach( ( element ) =>
		{
			const id = parseInt( element.getAttribute( 'data-id' ) );
			const quantity = parseInt( element.getAttribute( 'data-quantity' ) );
			const type = element.getAttribute( 'data-type' );
			let childProduct;

			switch ( type )
			{
				default:
					childProduct = new WMUWCBundleChildProduct();
					break;
				
				case 'variable':
					childProduct = new WMUWCBundleChildProductVariable();
					element.querySelectorAll( this.variableAttributeSelectSelector ).forEach( ( select ) => childProduct.addAttributeSelect( select ) );
					break;
			}

			childProduct.element = element;
			childProduct.id = id;
			childProduct.quantity = quantity;
			childProduct.type = type;

			this.childrenProductList.push( childProduct );
		} );
	}

	/**
	 * 
	 */
	fetchVariations()
	{
		const formData = new FormData();
		formData.append( 'action', wmuwcAddToCartBundleArgs.actionGetVariations );
		formData.append( '_ajax_nonce', wmuwcAddToCartBundleArgs.nonce );
		formData.append( 'bundle_id', this.bundleId );
		
		const childrenData = {};
		const variationIds = {};
		let hasChildrenData = false;

		this.childrenProductList.forEach( ( childProduct ) =>
		{
			if ( childProduct instanceof WMUWCBundleChildProductVariable )
			{
				if ( childProduct.isVariationNeedsRefresh() )
				{
					childrenData[ childProduct.id ] = childProduct.getVariationData();
					hasChildrenData = true;
				}

				if ( childProduct.variationId )
				{
					variationIds[ childProduct.id ] = childProduct.variationId;
				}
			}
		} );

		if ( ! hasChildrenData ) return;

		this.addToCartBtnDisable( true );

		formData.append( 'children_data', JSON.stringify( childrenData ) );
		formData.append( 'variation_ids', JSON.stringify( variationIds ) );

		const fetchInit = {
			method: 'POST',
			cache: 'no-cache',
			body: formData,
		};

		fetch( wmuwcAddToCartBundleArgs.ajaxUrl, fetchInit )
			.then( ( response ) => response.json() )
			.then( ( data ) =>
			{
				let needsUpdate = false;

				if ( true === data.success )
				{
					if ( data.data )
					{
						if ( data.data.childrenData )
						{
							Object.getOwnPropertyNames( data.data.childrenData ).forEach( ( childId ) =>
							{
								const childProduct = this.getChildProduct( parseInt( childId ) );
	
								if ( childProduct )
								{
									childProduct.variationId = data.data.childrenData[ childId ]['variationId'];
									childProduct.variationAttributes = data.data.childrenData[ childId ]['attributes'];
								}
							} );
	
							needsUpdate = true;
						}

						if ( data.data.price && data.data.priceHtml )
						{
							this.price = data.data.price;
							this.priceHtml = data.data.priceHtml;
						}
					}

					this.addToCartBtnEndLoading();

					if ( needsUpdate )
					{
						this.updateBundle();
					}
					else if ( this.isChildrenValid() )
					{
						this.addToCartBtnEnable();
					}
				}
				else
				{
					console.error( data );
				}
			} )
			.catch( ( error ) =>
			{
				console.error( error );
			} );
	}

	/**
	 * 
	 * @param {Number} id 
	 */
	getChildProduct( id )
	{
		return this.childrenProductList.find( ( childProduct) => childProduct.id == id );
	}

	/**
	 * 
	 */
	isChildrenValid()
	{
		for ( let i = 0, c = this.childrenProductList.length; i < c; i++ )
		{
			if ( ! this.childrenProductList[ i ].isValid() ) return false;
		}

		return true;
	}
	
	/**
	 * 
	 * @param {Boolean} isLoading 
	 */
	addToCartBtnDisable( isLoading = false )
	{
		document.querySelectorAll( this.addToCartBtnSelector ).forEach( ( btnElement ) =>
		{
			btnElement.classList.add( 'disabled' );
			btnElement.setAttribute( 'disabled', 'disabled' );

			if ( isLoading )
			{
				if ( ! btnElement.loadingElement )
				{
					const template = document.querySelector( '#wmu-element-state-loading' );
					
					if ( template )
					{
						btnElement.loadingElement = template.content.firstElementChild.cloneNode( true );
					}
				}
				
				if ( btnElement.loadingElement )
				{
					btnElement.appendChild( btnElement.loadingElement );
					btnElement.classList.add( 'loading' );
				}
			}
		} );
	}

	/**
	 * 
	 */
	addToCartBtnEnable()
	{
		document.querySelectorAll( this.addToCartBtnSelector ).forEach( ( btnElement ) =>
		{
			btnElement.classList.remove( 'disabled' );
			btnElement.removeAttribute( 'disabled' );
		} );
	}

	/**
	 * 
	 */
	addToCartBtnEndLoading()
	{
		document.querySelectorAll( this.addToCartBtnSelector ).forEach( ( btnElement ) =>
		{
			if ( btnElement.classList.contains( 'loading' ) )
			{
				btnElement.removeChild( btnElement.loadingElement );
				btnElement.classList.remove( 'loading' );
			}
		} );
	}

	/**
	 * 
	 */
	updateBundle()
	{
		const variationIdsInput = document.querySelector( this.variationIdsInputSelector );

		if ( this.isChildrenValid() )
		{
			this.addToCartBtnEnable();

			if ( variationIdsInput )
			{
				let variationIds = '';
				let childProduct;
				let variableCount = 0;

				for ( let i = 0, c = this.childrenProductList.length; i < c; i++ )
				{
					childProduct = this.childrenProductList[ i ];

					if ( childProduct instanceof WMUWCBundleChildProductVariable )
					{
						if ( variableCount > 0 )
						{
							variationIds += '&';
						}

						variationIds += `${ childProduct.id }=${ childProduct.variationId }`;
						variableCount++;
					}
				}

				variationIdsInput.value = variationIds;
			}
		}
		else
		{
			this.addToCartBtnDisable();

			if ( variationIdsInput )
			{
				variationIdsInput.value = 0;
			}
			
		}

		if ( this.priceHtml )
		{
			document.querySelectorAll( this.priceElementSelector ).forEach( ( priceElement ) =>
			{
				priceElement.innerHTML = this.priceHtml;
			} );
		}
	}

	/**
	 * 
	 * @param {Event} event 
	 */
	onDOMContentLoaded( event )
	{
		this.findBundleId();
		this.findChildrenProduct();
	}

	/**
	 * 
	 * @param {Event} event 
	 */
	onChildVariationRefresh( event )
	{
		if ( this.refreshVariationTimeoutId )
		{
			clearTimeout( this.refreshVariationTimeoutId );
			this.refreshVariationTimeoutId = undefined;
		}

		this.refreshVariationTimeoutId = setTimeout( this.onChildVariationRefreshTimeout, 500 );
	}

	/**
	 * 
	 */
	onChildVariationRefreshTimeout()
	{
		this.fetchVariations();
		this.refreshVariationTimeoutId = undefined;
	}

}

export default WMUWCAddToCartBundle;